import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PathCard } from '@/shared/ui/path-card'

export const Route = createFileRoute('/_auth/canteen/menu-settings/')({
  staticData: {
    meta: {
      title: 'Настройка меню',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PageWrapper title={t('Настройка меню')}>
      <PathCard path="/canteen/menu-settings/catalog-menu" title={t('Каталог меню')} />
      <PathCard path="/canteen/menu-settings/dishes" title={t('Блюда')} />
    </PageWrapper>
  )
}
